import React from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export const Layout = ({ children, showFooter = true, className = "" }) => (
  <div className="relative min-h-screen bg-[#050814] text-white">
    <Navbar />
    <main className={`pt-16 ${className}`}>{children}</main>
    {showFooter && <Footer />}
    <div className="h-20 lg:hidden" />
  </div>
);

export default Layout;
